/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Fragment } from "react";
import classNames from "classnames";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Typography } from "@mui/material";
import Button from "components/Buttons/ThemeButton";
import { CrownIcon, CrownIconV2 } from "utils/svgIcons";
import { FeaturesFlags } from "helpers";
// import { CardFinalMessage } from "styles/general_styles";
import { CrossedOutText } from "styles/general_styles";
import {
	Container,
	Items,
	RewardItem,
	ItemImage,
	RewardAmount,
	RewardAmountContainer,
	Footer,
	LoyaltyPoints,
	OfferText,
	BouncyChestButton,
	CustomLoyaltyPointsV2,
	LoyaltyValue
} from "./styles";
import { getClassNameVariant } from "components/DIP/helper";
import { getFlexBasis } from "../../helper";
import { DipButton } from "interfaces";
import { useDIPRewardsV2 } from "components/DIP/hooks/useDIPRewardsV2";
import { useDIPAction } from "components/DIP/hooks";
import { useAppSelector } from "hooks";
import { selectDipState } from "redux/slices";
import { useEnvContext } from "contexts";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { sortBundleRewards } from "helpers/rewardSort";

interface Props {
	item: DipButton;
	buttons: DipButton[];
	bouncyChestClass: string;
}

export const OfferItem: React.FC<Props> = ({
	item,
	buttons,
	bouncyChestClass
}) => {
	const { claimRewardProcess } = useAppSelector(selectDipState);
	const { loading } = claimRewardProcess;
	// Temporarily hidden per product request; restore this state with the JSX below
	// to re-enable the Poi's Bounty messaging, including Bouncy Chest offers.
	// const { canContribute: isPoisActive } = useAppSelector(
	// 	selectPoisBountyV3State
	// );
	const { isFeatureFlagEnabled } = useEnvContext();
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const isMobile = isPortrait;
	const showOfferId = useSelector(
		(state: RootState) => state.debug.showDebugLabels
	);
	const { onAction } = useDIPAction();
	const arrayTest = [1, 2, 3, 4, 5, 6, 7, 8];

	const {
		price,
		buyType,
		buttonLabel,
		rewards,
		loyaltyPointReward,
		loyaltyPointCrossout
	} = useDIPRewardsV2(item);

	return (
		<>
			<Container
				className={classNames([
					getClassNameVariant(buttons.length),
					loyaltyPointReward && "loyalty-reward",
					"item-reward",
					bouncyChestClass
				])}
			>
				{showOfferId && (
					<Typography
						sx={{
							fontWeight: 700,
							color: "red",
							fontSize: "12px",
							height: "auto",
							textAlign: "center"
						}}
					>
						{item.loyaltyOfferId ? item.loyaltyOfferId : item.offerId}
					</Typography>
				)}
				<Items
					className={classNames([
						getClassNameVariant(buttons.length),
						"bundle-rewards-item"
					])}
				>
					{/* {arrayTest.map(({}, key) => {
						const flexBasis = getFlexBasis(
							buttons as unknown as DipButton[],
							arrayTest,
							isMobile
						);

						return (
							<RewardItem key={key} width={flexBasis + "%"}>
								<ItemImage
									src={
										"https://cdn.solitairetripeaks.com/WebStore/reward_images/coin.png"
									}
									alt=""
								/>

								<RewardAmount>{200}</RewardAmount>
							</RewardItem>
						);
					})} */}

					{sortBundleRewards(rewards).map(
						({ imageUrl, description, id }, key) => {
							const flexBasis = getFlexBasis(
								buttons,
								rewards,
								isMobile,
								bouncyChestClass
							);

							return (
								<RewardItem
									className={bouncyChestClass}
									key={key}
									width={flexBasis + "%"}
								>
									<ItemImage src={imageUrl} alt="" />
									<RewardAmountContainer className={bouncyChestClass}>
										<RewardAmount className={bouncyChestClass}>
											{bouncyChestClass && id !== "coin" && "x"}
											{description}
										</RewardAmount>
									</RewardAmountContainer>
								</RewardItem>
							);
						}
					)}
				</Items>

				<Footer
					className={classNames([
						loyaltyPointReward && "loyalty-reward",
						getClassNameVariant(buttons.length),
						bouncyChestClass
					])}
				>
					{loyaltyPointReward && (
						<>
							{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
								<CustomLoyaltyPointsV2>
									{loyaltyPointCrossout && (
										<CrossedOutText>
											Earn <CrownIconV2 height={"0.9em"} />
											{Number(loyaltyPointCrossout)?.toLocaleString("en-US")}
										</CrossedOutText>
									)}
									<LoyaltyValue>
										Earn <CrownIconV2 height={"1.1em"} />
										{loyaltyPointReward?.toLocaleString("en-US")}
									</LoyaltyValue>
									{/*
										{isPoisActive && (
											<CardFinalMessage
												color="#FBBD05"
												style={{ fontSize: "0.8em" }}
											>
												Contribute to Poi’s Bounty
											</CardFinalMessage>
										)}
									*/}
								</CustomLoyaltyPointsV2>
							) : (
								<LoyaltyPoints>
									<div>
										Earn <CrownIcon width={16} />
										{loyaltyPointReward?.toLocaleString("en-US")}
									</div>
									{/*
										{isPoisActive && (
											<CardFinalMessage color="#FBBD05">
												Contribute to Poi’s Bounty
											</CardFinalMessage>
										)}
									*/}
								</LoyaltyPoints>
							)}
						</>
					)}
					{!bouncyChestClass && (
						<Button
							disabled={loading}
							onClick={() => onAction(item, price)}
							style={{ fontSize: "1em", height: "3.2em" }}
						>
							{!buttonLabel ? (
								<Fragment>
									{buyType === "loyalty_points" && <CrownIcon width={16} />}
									{price}
									{buyType === "usd" && " USD"}
								</Fragment>
							) : (
								buttonLabel
							)}
						</Button>
					)}
					{bouncyChestClass && (
						<OfferText>
							*This offer is limited to a single purchase per user
						</OfferText>
					)}
				</Footer>
			</Container>
			{bouncyChestClass && (
				<BouncyChestButton
					disabled={loading}
					onClick={() => onAction(item, price)}
				>
					{!buttonLabel ? (
						<Fragment>
							{buyType === "loyalty_points" && <CrownIcon width={16} />}
							{price}
							{buyType === "usd" && " USD"}
						</Fragment>
					) : (
						buttonLabel
					)}
				</BouncyChestButton>
			)}
		</>
	);
};

export default OfferItem;
